
export class SendEmailModel {
    BeneficiaryEmail: string
    BeneficiaryName: string

}
